import * as React from "react";
import { PaymentStatus as PaymentStatusLiterals } from "@graffer-inc/cloud-gov-core";
import { matchType } from "../../../../application/domain/base/base-type";
import { SecondaryStatusTag } from "@graffer-inc/console-design-kit";

export type PaymentStatusTagProps = {
  status: PaymentStatusLiterals;
};
export const PaymentStatusTag: React.FC<PaymentStatusTagProps> = ({
  status,
}) => {
  return matchType(status, {
    paid: <SecondaryStatusTag type="SUCCESS">支払い済み</SecondaryStatusTag>,
    partial_refunded: (
      <SecondaryStatusTag type="LIGHT">一部返金済み</SecondaryStatusTag>
    ),
    refunded: (
      <SecondaryStatusTag type="LIGHT">全額返金済み</SecondaryStatusTag>
    ),
    requested: (
      <SecondaryStatusTag type="PRIMARY">支払い依頼中</SecondaryStatusTag>
    ),
    cancelled: (
      <SecondaryStatusTag type={"DARK"}>キャンセル済み</SecondaryStatusTag>
    ),
    exceeding_payment: (
      <SecondaryStatusTag type={"ERROR"}>過入金</SecondaryStatusTag>
    ),
    deficient_payment: (
      <SecondaryStatusTag type={"ERROR"}>入金不足</SecondaryStatusTag>
    ),
  });
};
